// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_sflpro_dresscode_lib_Autocomplete_index_js-node_modules_sflpro_dresscode-a5541e":"25c75150e806a92c6196","app_src_components_App_js":"5d421791d4e8e0088919"}[chunkId] + ".bundle.js";
};